<div class="ac-flex ac-algn-ctr ac-gap-md">
  <div class="avatar ac-flex ac-ctr">
    <img
      [src]="
        user().avatar_url ?? ('cdnUrl' | env) + '/images/default_avatar.webp'
      "
      alt="user-avatar"
    />
  </div>
  <div class="detail ac-flex-col">
    <div class="username ac-title-md">{{ user().username }}</div>
    @if (user().subtitle) {
    <div class="email ac-label ac-body-sm">{{ user().subtitle }}</div>
    }
  </div>
</div>
